'use strict'

console.log('atProduct');

const CHEVRON_RIGHT = `<svg class="chevron-down-light" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 36 36" fill="none">
  <path d="M10.7998 14.4001L17.9998 21.6001L25.1998 14.4001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

const MODAL_GALLERY_TEMPLATE = `<div id="show-image-modal">
  <span id="modal-close-button">
    <svg class="icon close" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
        fill="#0F0F0F" />
    </svg>
  </span>
  <span class="slider-image-switcher">
    <span class="control-btn prev-btn">${CHEVRON_RIGHT}</span>
    <span class="control-btn next-btn">${CHEVRON_RIGHT}</span>
  </span>
  <div id="modal-inner-container"></div>
</div>`;

function productMediaGallery() {
  const html = document.querySelector('html');
  const container = document.querySelector('.product-information__media media-gallery:where(.media-gallery--grid)');
  if (!container) {
    console.warn('Media gallery container not found.');
    return;
  }

  const grid = container.querySelector('.media-gallery__grid');
  const itemSelector = 'li.product-media-container.constrain-height.media-fit-contain.product-media-container--image';
  const mediaItems = grid ? grid.querySelectorAll(itemSelector) : [];

  if (!mediaItems.length || !grid) {
    console.warn('Media gallery grid or items not found.');
    return;
  }

  const zoomButtons = container.querySelectorAll('.product-information__media button.product-media-container__zoom-button');
  zoomButtons.forEach(btn => {
    if (btn) btn.remove();
  });

  const zoomDialog = document.querySelector('.product-information__media zoom-dialog');
  if (zoomDialog) zoomDialog.remove();

  const innerContainer = document.createElement('div');
  innerContainer.id = 'clone-product-img';
  innerContainer.classList.add(
    'product-media-container',
    'constrain-height',
    'media-fit-contain',
    'product-media-container--image',
    'product-media-container--main'
  );

  const firstImage = mediaItems[0].querySelector('img');
  if (!firstImage) {
    console.error('First media item has no image.');
    return;
  }

  const mainImage = firstImage.cloneNode(true);
  innerContainer.appendChild(mainImage);

  container.appendChild(innerContainer);

  const galleryList = container.querySelector('.media-gallery__grid');

  const updateGalleryHeight = () => {
    let imageHeight = mainImage.offsetHeight;
    if (imageHeight > 0) {
      galleryList.style.maxHeight = `${imageHeight + 32}px`;
    }
  };

  if (mainImage.complete) {
    updateGalleryHeight();
  } else {
    mainImage.addEventListener('load', updateGalleryHeight);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateGalleryHeight, 100);
  });

  function setupImageZoom(container, image) {

    const ZOOM_LEVEL = 2;

    function setZoom(xOrigin, yOrigin, scale) {
      image.style.transformOrigin = `${xOrigin} ${yOrigin}`;
      image.style.transform = `scale(${scale})`;
    }

    container.addEventListener('mousemove', (event) => {
      const x = event.offsetX;
      const y = event.offsetY;

      setZoom(`${x}px`, `${y}px`, ZOOM_LEVEL);
    });

    container.addEventListener('mouseleave', () => {
      setZoom('50%', '50%', 1);
    });

    function touchscreenZoom() {
      image.closest('media-gallery').addEventListener('touchstart', (event) => {
        const rect = image.closest('media-gallery').getBoundingClientRect();
        const touch = event.touches[0];

        const x = touch.clientX - rect.left;
        const y = touch.clientY - rect.top;

        setZoom(`${x}px`, `${y}px`, ZOOM_LEVEL);

        html.style.overflow = 'hidden';
      });

      image.closest('media-gallery').addEventListener('touchmove', (event) => {
        const rect = image.closest('media-gallery').getBoundingClientRect();
        const touch = event.touches[0];

        const x = touch.clientX - rect.left;
        const y = touch.clientY - rect.top;

        setZoom(`${x}px`, `${y}px`, ZOOM_LEVEL);

        // html.style.overflow = 'hidden';
      });

      image.closest('media-gallery').addEventListener('touchend', () => {
        setZoom('50%', '50%', 1);

        html.style.overflow = '';
      });
    }
    // touchscreenZoom();

    function setupImageZoomTouchscreen() {
      const images = document.querySelectorAll('slideshow-container .product-media img');
      console.log('images', images);


      images.forEach(image => {
        function setZoom(xOrigin, yOrigin, scale) {
          image.style.transformOrigin = `${xOrigin} ${yOrigin}`;
          image.style.transform = `scale(${scale})`;
        }

        image.style.transition = 'transform .5s';

        image.closest('media-gallery').addEventListener('touchstart', (event) => {
          const rect = image.closest('media-gallery').getBoundingClientRect();
          const touch = event.touches[0];

          const x = touch.clientX - rect.left;
          const y = touch.clientY - rect.top;

          setZoom(`${x}px`, `${y}px`, ZOOM_LEVEL);
        });

        image.closest('media-gallery').addEventListener('touchmove', (event) => {
          const rect = image.closest('media-gallery').getBoundingClientRect();
          const touch = event.touches[0];

          const x = touch.clientX - rect.left;
          const y = touch.clientY - rect.top;

          setZoom(`${x}px`, `${y}px`, ZOOM_LEVEL);
        });

        image.closest('media-gallery').addEventListener('touchend', () => {
          setZoom('50%', '50%', 1);
        });
      });
    }
    // setupImageZoomTouchscreen();

  }
  setupImageZoom(innerContainer, mainImage);

  grid.addEventListener('click', (event) => {
    const clickedItem = event.target.closest(itemSelector);

    if (!clickedItem) return;

    event.preventDefault();

    const newImage = clickedItem.querySelector('img');
    if (!newImage) return;

    mainImage.src = newImage.src;
    mainImage.alt = newImage.alt;

    if (newImage.hasAttribute('srcset')) {
      mainImage.srcset = newImage.getAttribute('srcset');
    } else {
      mainImage.removeAttribute('srcset');
    }

    if (newImage.hasAttribute('sizes')) {
      mainImage.sizes = newImage.getAttribute('sizes');
    } else {
      mainImage.removeAttribute('sizes');
    }

    const updateGalleryHeight = () => {
      const imageHeight = mainImage.offsetHeight;
      if (imageHeight > 0) {
        galleryList.style.maxHeight = `${imageHeight}px`;
      }
    };

    if (mainImage.complete) {
      updateGalleryHeight();
    } else {
      mainImage.addEventListener('load', updateGalleryHeight);
    }
  });

  const photosSection = document.querySelector('[data-id="live_photos"]') ? document.querySelector('[data-id="live_photos"]').parentElement : null;
  const videosSection = document.querySelector('[data-id="video_review"]') ? document.querySelector('[data-id="video_review"]').parentElement : null;

  function productMediaScrollController() {
    const scrollController = document.getElementById('at-scroll-controller');
    const mediaContainer = document.querySelector('.product-information__media media-gallery:where(.media-gallery--grid) .media-gallery__grid');
    if (!scrollController || !mediaContainer) return;

    mediaContainer.addEventListener('click', () => {
      scrollController.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    });
  }
  productMediaScrollController();

  function setupMediaTabs(container) {
    const controlsContainer = document.querySelector('[data-id="media-buttons-control"]');
    if (controlsContainer) controlsContainer.id = 'media-buttons-control';

    controlsContainer.addEventListener('click', () => {
      if (controlsContainer) {
        controlsContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });

    const photosBtn = controlsContainer.querySelector('.custom-section-content .section-content-wrapper>:first-child:is(a)');
    const videosBtn = controlsContainer.querySelector('.custom-section-content .section-content-wrapper>:last-child:is(a)');

    if (photosBtn) {
      const imageBlocks = photosSection.querySelectorAll('.image-block');
      imageBlocks.forEach(block => {
        const img = block.querySelector('img');
        if (!img) {
          block.style.display = 'none';
          block.remove();
        }
      });
    }

    if (videosSection) {
      const videoPlaceholderWrappers = videosSection.querySelectorAll('.video-placeholder-wrapper');
      videoPlaceholderWrappers.forEach(block => {
        if (block) {
          block.style.display = 'none';
          block.remove();
        }
      });
    }

    if (!photosSection || !videosSection) {
      console.error('The photo or video section could not be found. The buttons will not work.');
      controlsContainer.style.display = 'none';
      return;
    }

    const hasPhotos = photosSection.querySelector('img');
    if (!hasPhotos) {
      photosBtn.style.display = 'none';
    }

    const defferContainers = videosSection.querySelectorAll('deferred-media');

    const hasVideos = Array.from(defferContainers).some(
      container => container.querySelector('template')?.content.querySelector('video')
    );

    if (!hasVideos) {
      videosBtn.style.display = 'none';
    }

    if (!hasPhotos && !hasVideos) {
      controlsContainer.style.display = 'none';
    }

    photosBtn.addEventListener('click', (e) => {
      e.preventDefault();
      photosSection.style.display = 'block';
      videosSection.style.display = 'none';
      videosBtn.style.backgroundColor = '';
      photosBtn.style.backgroundColor = '#f2f2f6';
    });

    const url = new URL(location);
    if (url.hash === '#media-buttons-control') {
      photosSection.style.display = 'block';
      videosSection.style.display = 'none';
      videosBtn.style.backgroundColor = '';
      photosBtn.style.backgroundColor = '#f2f2f6';
    }

    videosBtn.addEventListener('click', (e) => {
      e.preventDefault();
      videosSection.style.display = 'block';
      photosSection.style.display = 'none';
      videosBtn.style.backgroundColor = '#f2f2f6';
      photosBtn.style.backgroundColor = '';

      const activeVideos = videosSection.querySelectorAll('video');
      activeVideos.forEach(video => {
        if (video && !video.paused) {
          video.pause();
        }
      });
    });
  }
  if (container) {
    setupMediaTabs(container);
  } else {
    console.error('No media button container found.');
  }

  function modalGallery() {
    container.insertAdjacentHTML('afterend', MODAL_GALLERY_TEMPLATE);
    const modal = document.getElementById('show-image-modal');
    const modalCloseBtn = document.getElementById('modal-close-button');
    const modalInnerContainer = document.getElementById('modal-inner-container');
    // console.log('Modal elements:', { modal, modalCloseBtn, modalInnerContainer });

    const slideSwitcher = document.querySelector('.slider-image-switcher');
    const prevBtn = slideSwitcher.querySelector('.prev-btn');
    const nextBtn = slideSwitcher.querySelector('.next-btn');

    function drawImage(img) {
      modalInnerContainer.innerHTML = '';
      const modalImage = img.cloneNode(true);
      modalInnerContainer.appendChild(modalImage);
      modal.classList.add('active');
      html.style.overflowY = 'hidden';
    }

    function setOpacity(el) {
      setTimeout(() => {
        el = document.querySelector('#modal-inner-container img')
        el.style.opacity = '1';
      }, .100);
    }

    const images = photosSection.querySelectorAll('img');
    let n = 0;

    for (let i = 0; i < images.length; i++) {
      images[i].addEventListener('click', () => {
        drawImage(images[i]);
        setOpacity(images[i]);
        n = i;
      });
    }

    nextBtn.addEventListener('click', () => {
      for (let i = 0; i < images.length; i++) {
        if (n < images.length - 1) {
          drawImage(images[n + 1]);
          setOpacity(images[i]);
        }
      }
      if (n < images.length - 1) {
        n++;
        nextBtn.style.opacity = '';
        prevBtn.style.opacity = '';
      } else {
        nextBtn.style.opacity = '0';
      }
    });

    prevBtn.addEventListener('click', () => {
      for (let i = 0; i < images.length; i++) {
        if (n > 0) {
          drawImage(images[n - 1]);
          setOpacity(images[i]);
        }
      }
      if (n > 0) {
        n--;
        nextBtn.style.opacity = '';
        prevBtn.style.opacity = '';
      } else {
        prevBtn.style.opacity = '0';
      }

    });

    function reset() {
      modal.classList.remove('active');
      modalInnerContainer.innerHTML = '';
      html.style.overflowY = '';
      nextBtn.style.opacity = '';
      prevBtn.style.opacity = '';
      n = 0;
    }

    modalCloseBtn.addEventListener('click', () => {
      reset();
    });

    window.addEventListener('click', (e) => {
      if (e.target === modal) {
        reset();
      }
    });

  }
  modalGallery();

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, productMediaGallery)
);

function showStockAttribute() {
  const dataStock = document.querySelector('.product-information.section .custom-tag-badge')
  const stockAttributes = document.querySelectorAll('.product-details .stock');
  // console.log(dataStock);

  stockAttributes.forEach(element => {
    if (dataStock.getAttribute('data-stock') === 'in-stock') {
      if (element.getAttribute('data-role') === 'in-stock') element.style.display = '';
    } else {
      if (element.getAttribute('data-role') === 'in-stock') element.parentElement.remove();
    }
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, showStockAttribute)
);

function productInfoReplace() {
  const outer = document.querySelector('.product-details table');
  // console.log('outer', outer);
  if (!outer) return;

  const tbody = outer.querySelectorAll('tbody');
  tbody.forEach(element => {
    if (!element.textContent) element.remove();
  });

  if (outer.style) outer.removeAttribute('style');

  const buttons = outer.querySelectorAll('button');
  buttons.forEach(button => {
    if (button) button.remove();
  });

  const elements = outer.querySelectorAll('*'); // th, tr, td, p, h3, h5
  elements.forEach(element => {
    if (element.style) element.removeAttribute('style');
    if (element) element.removeAttribute('class');
  });


  const container = document.querySelector('#product-info-insert-container');
  if (!container) return;

  function linkRemove() {
    const textLinks = outer.querySelectorAll('tr td a');
    if (!textLinks.length) return;
    textLinks.forEach(textLink => {
      const linkText = textLink ? textLink.textContent : null;
      // console.log('linkText', linkText);
      if (textLink.parentElement && linkText) textLink.parentElement.innerHTML = linkText;
    });
  }
  linkRemove();

  const html = outer ? outer.outerHTML : null;

  container.innerHTML = html;

  outer.closest('rte-formatter.text-block').remove();

  const innerElements = container.querySelectorAll('table tbody');
  // console.log('innerElements', innerElements);
  if (!innerElements) return;
  innerElements.forEach(element => {
    element.addEventListener('click', () => {
      // innerElements.forEach(el => {
      //     if (el !== element) el.classList.remove('open');
      // });
      element.classList.toggle('open');
    });
  });

}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, productInfoReplace)
);